import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Form, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { faAngleLeft, faAngleRight, faCheck, faFileExcel, faMagnifyingGlass, faPen, faPenToSquare, faSquareCheck, faSquarePlus, faSquareXmark, faTrash, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { validateAllFormFields } from '../../../common/utils';

@Component({
    selector: 'app-add-cameras',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule, FormsModule],
    templateUrl: './add-cameras.component.html',
    styleUrl: './add-cameras.component.css'
})
export class AddCamerasComponent implements OnInit {
 
  cameraForm!: FormGroup;
  organizationInfo:any = {
    orgId:'',
    orgName:'',

  }
  directionChoice: any  = [
                    'ENTRY',
      'EXIT',
      'BIDIRECTIONAL'
                  ];

  constructor(private apiService: ApiService,
              library: FaIconLibrary,
              private router: Router,
              private toastr:ToastrService,
              private fb: FormBuilder,
             private route: ActivatedRoute) {

    library.addIcons(
                    faSquarePlus,
                    faSquareXmark
                  );

    
    
  }
  ngOnInit() {
    // Get the token from query parameters
    this.route.queryParams.subscribe(params => {
      // console.log(params)
      this.organizationInfo['orgId'] = params['id'];
      this.organizationInfo['orgName'] = params['name'];
    });
    this.cameraForm = this.fb.group({
        cameraESN: ['', Validators.required],
      organization: [this.organizationInfo['orgName'], Validators.required],
      direction: ['ENTRY', Validators.required],
      description: ['', Validators.required]
    })
  }

  onSubmit(){
    if (this.cameraForm.valid){
      let formData = new FormData();
      formData.append('organization_id', this.organizationInfo['orgId'])
        formData.append('camera_esn', (this.cameraForm.value.cameraESN || '').trim())
      formData.append('direction', this.cameraForm.value.direction)
      formData.append('description', this.cameraForm.value.description)
     
      this.apiService.addcamera(formData).subscribe({
        next: (res: any) => {
          this.toastr.success("New Camera Added Successfully", 'Success');
          // this.router.navigate(['organization'], {state: {'activeTab': 'customer'}})
          // this.router.navigate(['organization'])
          this.router.navigate(['view-cameras'], { queryParams: {'id': this.organizationInfo['orgId'], 'name': this.organizationInfo['orgName']}})
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['camera_esn']) {
            err['error']['camera_esn'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['organization']) {
            err['error']['organization'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['direction']) {
            err['error']['direction'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['error']['description']) {
            err['error']['description'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }  else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }
        }
      }) 

  }else{
    validateAllFormFields(this.cameraForm)
  }
  }
  
  onCancel() {
    //  this.router.navigate(['organization'], {state: {'activeTab': 'customer'}})
    this.router.navigate(['view-cameras'], { queryParams: {'id': this.organizationInfo['orgId'], 'name': this.organizationInfo['orgName']}})

  }
}
